import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

const SECTION_ID_PREFIX = 'shopify-section-';

/**
 * Keeps the header's item counter (snippets/header-filters-bar.liquid) and
 * the filters drawer's applied-filters row in sync with facet changes.
 *
 * assets/facets.js only re-renders the results grid section ("main") after
 * a filter change — the counter and the applied-filters row live in
 * separate sections (the header, and this drawer), so they'd otherwise show
 * stale data. Hydration-mode re-renders touch only the element carrying a
 * matching `data-hydration-key`, leaving everything else in those
 * sections — notably the drawer's own open `<dialog>` state — untouched.
 *
 * @extends {Component}
 */
class HeaderFiltersSyncComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.collectionUpdate, this.#onFiltersUpdate);
    document.addEventListener(StandardEvents.searchUpdate, this.#onFiltersUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.collectionUpdate, this.#onFiltersUpdate);
    document.removeEventListener(StandardEvents.searchUpdate, this.#onFiltersUpdate);
  }

  /**
   * @param {Event & { promise?: Promise<unknown> }} event
   */
  #onFiltersUpdate = (event) => {
    event.promise
      ?.then(() => {
        sectionRenderer.renderSection('header-filters-drawer', { mode: 'hydration', cache: false });

        const headerSectionId = document
          .getElementById('header-component')
          ?.closest('.shopify-section')
          ?.id.replace(new RegExp(`^${SECTION_ID_PREFIX}`), '');

        if (headerSectionId) {
          sectionRenderer.renderSection(headerSectionId, { mode: 'hydration', cache: false });
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[header-filters-sync] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('header-filters-sync')) {
  customElements.define('header-filters-sync', HeaderFiltersSyncComponent);
}
